export default function (pagination) {
  const { page, total } = pagination;

  return {
    currentPage: page.number,
    totalPages: total.pages,
    totalRecords: total.records,
  };
}
